import { Language } from './language.model'
export class CityCountry {
  code2: string = 'CL';
  name: string = 'Chile';
  name_es: 'Chile';
  continent: 'South America';
  language: Language = {id: 1, code: "es"};
}
